module.exports = __webpack_public_path__ + "static/media/pointsRaceIcon.e1b03030.png";